import type {WarehouseMovementsQuery} from '@prompt-bridge/shared/validations';

import {getSafely} from 'shared/web';

export function warehouseMovementsSearchParams(filters: WarehouseMovementsQuery) {
  const params = new URLSearchParams({from: filters.from, to: filters.to});
  for (const key of ['warehouse', 'manufacturer', 'supplier'] as const) {
    for (const value of getSafely(filters, key) ?? []) {
      params.append(key, value);
    }
  }
  return params.toString();
}
